/* Showpo-style Quick add: a bar on the bottom of the product photo. Tap it and the
   size chips appear just above it; tap a size and it goes straight into the cart.
   No "CHOOSE OPTIONS", no quick-view modal.

   The chips and the button are both the theme's own - the chips carry variant JSON
   and already add to cart in one tap. This moves them into a single wrapper pinned
   to the bottom of the image, relabels the button, and controls when the chips
   show. Single-variant products keep the theme's direct add.

   TOUCH: the figure carries .thb-hover, the theme's hover image-carousel. On a
   touchscreen the first tap counts as a hover, so tapping Quick add was swapping
   the card to the next image. Blocking click alone did not stop it - the carousel
   listens on pointer/mouse/touch events. We stop those at the wrapper in the
   BUBBLE phase: descendants (the chips) have already had the event, but the
   figure's carousel handler never sees it. Capture phase would break the chips.
   Verified with real CDP touch events, not synthetic clicks.

   Rebuy's Smart Cart flyout still opens after an add - deliberate. It carries the
   free-shipping progress bar (AOV $162 vs a $200 threshold) and the upsell. */
(function () {
	var CARD = 'product-card, .product-card';
	var SWALLOW = ['mouseover', 'mouseout', 'mousemove', 'mouseenter', 'mouseleave',
		'pointerover', 'pointerout', 'pointerdown', 'pointerup', 'pointerenter', 'pointerleave',
		'touchstart', 'touchmove', 'touchend'];

	function build(card) {
		if (card.querySelector('.ltl-qa-wrap')) return;
		var link = card.querySelector('.product-card--featured-image-link');
		var box = card.querySelector('.product-card-sizes--container');
		var btnBox = card.querySelector('.product-card--add-to-cart-button-container');
		if (!link || !btnBox) return;

		var wrap = document.createElement('div');
		wrap.className = 'ltl-qa-wrap';
		if (box) wrap.appendChild(box);      // chips first - they stack above the bar
		wrap.appendChild(btnBox);
		link.appendChild(wrap);

		// don't follow the product link when tapping inside the wrapper
		wrap.addEventListener('click', function (e) { e.preventDefault() }, true);

		// don't let the hover-carousel see pointer activity over the wrapper
		SWALLOW.forEach(function (ev) {
			wrap.addEventListener(ev, function (e) { e.stopPropagation() }, false);
		});
	}

	/* Size the bar to the RENDERED photo, not the card. The theme uses
	   object-fit:contain, so a 2:3 image in a 318x397 box paints 265px wide and a
	   full-width bar overhangs the picture into the grey letterbox. Only applies
	   when the fit really is `contain` - with `cover` the photo fills the box and
	   full width is already correct. */
	function fitWidth(card) {
		var fig = card.querySelector('.product-card--featured-image-link');
		var wrap = card.querySelector('.ltl-qa-wrap');
		var img = card.querySelector('.product-primary-image') || card.querySelector('img');
		if (!fig || !wrap || !img) return;
		if (getComputedStyle(img).objectFit !== 'contain') return;
		var nw = img.naturalWidth, nh = img.naturalHeight;
		if (!nw || !nh) {                       // not decoded yet
			if (!img.dataset.ltlFitWait) {
				img.dataset.ltlFitWait = '1';
				img.addEventListener('load', function () { fitWidth(card) }, { once: true });
			}
			return;
		}
		var r = fig.getBoundingClientRect();
		if (!r.width || !r.height) return;
		var w = Math.round(Math.min(r.width, r.height * nw / nh));
		if (wrap.dataset.ltlW === String(w)) return;   // no layout write if unchanged
		wrap.dataset.ltlW = String(w);
		wrap.style.setProperty('--ltl-qa-w', w + 'px');
	}

	function relabel() {
		document.querySelectorAll('.product-card--add-to-cart-text').forEach(function (t) {
			if (/choose options/i.test(t.textContent || '')) t.textContent = 'Quick add';
		});
	}

	function init() {
		document.querySelectorAll(CARD).forEach(function (c) { build(c); fitWidth(c) });
		relabel();
	}

	/* The MutationObserver below fires on every DOM change, and init() measures
	   layout - coalesce to one pass per frame so we never thrash. */
	var queued = false;
	function schedule() {
		if (queued) return;
		queued = true;
		requestAnimationFrame(function () { queued = false; init() });
	}

	/* Quick add toggles the chips (capture beats the quick-view handler) */
	document.addEventListener('click', function (e) {
		var btn = e.target.closest && e.target.closest('.product-card--add-to-cart-button');
		if (!btn) return;
		var card = btn.closest(CARD);
		var box = card && card.querySelector('.product-card-sizes--container');
		if (!box) return;              // single variant - theme adds it directly
		e.preventDefault();
		e.stopImmediatePropagation();
		var open = card.classList.contains('ltl-open');
		document.querySelectorAll(CARD + '.ltl-open').forEach(function (o) { o.classList.remove('ltl-open') });
		if (!open) card.classList.add('ltl-open');
	}, true);

	/* collapse again once a size is chosen */
	document.addEventListener('click', function (e) {
		var chip = e.target.closest && e.target.closest('.product-card-sizes--size');
		var card = chip && chip.closest(CARD);
		if (card) setTimeout(function () { card.classList.remove('ltl-open') }, 350);
	}, true);

	/* tapping elsewhere closes an open card */
	document.addEventListener('click', function (e) {
		if (e.target.closest && e.target.closest('.ltl-qa-wrap')) return;
		document.querySelectorAll(CARD + '.ltl-open').forEach(function (o) { o.classList.remove('ltl-open') });
	});

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
	else init();
	document.addEventListener('shopify:section:load', schedule);
	window.addEventListener('resize', schedule);
	window.addEventListener('load', schedule);
	new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
